import { render } from "./manager_packets.vue?vue&type=template&id=db901ac8"
import script from "./manager_packets.vue?vue&type=script&lang=js"
export * from "./manager_packets.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__